import Vue from '../../../../../app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import { parseBoolean } from '@gitlab/frontend-utils';
import TierBadge from '../vue_shared/components/tier_badge/tier_badge.vue?vue3';

export default function initTierBadgeTrigger() {
  const el = document.querySelector('.js-tier-badge-trigger');

  if (!el) {
    return false;
  }

  const { primaryCtaLink, secondaryCtaLink, trialDuration, isProject } = el.dataset;

  return new Vue({
    el,
    name: 'TierBadgeTriggerRoot',
    components: {
      TierBadge,
    },
    provide: {
      primaryCtaLink,
      secondaryCtaLink,
      trialDuration,
      isProject: parseBoolean(isProject),
    },
    render(createElement) {
      return createElement(TierBadge, { attrs: { 'data-testid': 'group-tier-badge' } });
    },
  });
}
